<template>
  <div>
    <div class="bgimg-2"></div>

    <div class="quality-container">
      <div class="img-container">
        <img class="room-img" src="../assets/living-room.jpg">
      </div>
      <div class="text-block">
        <h1>High Quality homes in the East of England</h1>
        <p class="section-slogan"><b>We are local property investors and developers who love to share value.</b><br><br>With a combined 40 years experience our team and partners, have helped and worked with a number of people to get a great return through creative property investing and development.</p>

      </div>
    </div>

    <WorkingWithUs />

  </div>
</template>

<script>

import WorkingWithUs from '@/components/WorkingWithUs.vue'

export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  components: {
    WorkingWithUs
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  p {
    color: #000;
    text-align: left;
  }
  h1 {
    margin: 40px 0 20px 0;
    font-size: 62px;
    line-height: 0.8;
    color: #000;
    text-align: left;
  }
  a {
    color: #42b983;
  }

  .room-img {
    z-index: -1;
    position: absolute;
    max-width: 600px;
  }

  .img-container {
    display: inline-block;
    float: left;
  }

  .quality-container {
    padding: 100px 20px;
    max-width: 1000px;
    margin: auto;
  }

  .text-block {
    width: 520px;
    display: inline-block;
    padding-left: 520px;
    clear: both;
  }

  .text-block p {
    padding: 10px 0 0 100px;
  }

  .section-slogan {
    font-family: sans-serif;
    letter-spacing: 1.2px;
    margin-bottom: 0;
  }

  @media only screen and (max-width: 1280px) {

    h1 {
      font-size: 42px;
      margin: 20px 0;
    }

    .img-container {
      padding-top: 40px;
    }

    .quality-container {
      padding: 0 20px;
      width: 600px;
    }

    .text-block {
        max-width: 420px;
        display: block;
        padding-left: 0;
        padding-top: 460px;
    }

    .room-img {
      max-width: 300px;
    }

    .section-slogan {
      width: 200px
    }

  }

  @media only screen and (max-width: 680px) {
    img {
      width: 400px;
    }
    .quality-container {
      padding: 0 20px;
      width: 300px;
    }
    .text-block {
        max-width: 320px;
    }
    .text-block p {
      padding: 10px 0 0 60px;
    }
  }

</style>
